export const pages = [{ name: 'Employers', url: "/employer" },
// { name: 'Contact Us', url: "/contact-us" },
// { name: 'About', url: "/about" },
]